import {
  AfterViewInit, ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, Inject,
  Injector,
  NgZone,
  OnInit,
  ViewChild
} from '@angular/core';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {SignageInfoComponent} from './info/signage-info.component';
import {PlayerBaseService} from '../services/PlayerService/player.base.service';
import {Log, LogTag} from '../services/Log';
import {fromEvent} from 'rxjs';
import {DOCUMENT} from "@angular/common";
import {PlayerPwaService} from "../services/PlayerService/player.pwa.service";


@Component({
    selector: 'app-taskbar',
    templateUrl: './taskbar.component.html',
    styleUrls: ['./taskbar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskbarComponent implements OnInit, AfterViewInit {

  playerService: PlayerBaseService;
  buttonMode: boolean = false;
  show: boolean = false;
  timeoutId;
  dialogConfig;
  signageInfo;
  mousemove;
  kiosk;
  kioskKey = "";
  taskbarEnabled = false;
  isPlaying = false;
  isRegistered = false;
  _isConnected = false;
  extensionActive = false;
  isFullScreen;

  constructor(@Inject(DOCUMENT) private document: Document,
              protected injector: Injector,
              private cdRef: ChangeDetectorRef,
              private ngZone: NgZone,
              private dialog: MatDialog) {
    this.playerService = injector.get('playerService');
  }

  @ViewChild('container', {static: false}) container: ElementRef;
  @ViewChild('play', {static: false}) play: ElementRef;
  @ViewChild('stop', {static: false}) stop: ElementRef;

  // @ViewChild('server', {static: false}) server: ElementRef;

  ngOnInit() {
    this.dialogConfig = new MatDialogConfig();
    this.initToolbar();
  }

  ngAfterViewInit() {
    (this.playerService as PlayerBaseService).playing$.subscribe(value => {
      this.updateButtons();
    })
    this.container.nativeElement.style.display = "none";
  }

  get isConnected() {
    return this._isConnected && navigator.onLine;
  }


  initToolbar() {
    // this.server.nativeElement.style.color = '#FF0000';
    this.playerService.playerChannel$.subscribe(value => {
      switch (value.cmd) {
        case 'status':
          if (value.param == "signage") {
            this.isRegistered = true;
          }
          break;
        case 'server':
          if (value.param == 'connected') {
            // this.server.nativeElement.style.color = '#00FF00';
            this._isConnected = true;
            this.cdRef.markForCheck();
          } else if (value.param == 'closed') {
            // this.server.nativeElement.style.color = '#FF0000';
            this._isConnected = false;
            this.cdRef.markForCheck();
          }
          break;
        case 'watchdog':
          if (value.connected == '1') {
            this.extensionActive = true;
            this.cdRef.markForCheck();
          }
          break;
        case 'kiosk':
          this.setKiosk(value.enabled, value.key);
          break;
      }
    });


    this.mousemove = fromEvent(document, 'mousemove').subscribe((event) => {
      this.showToolbar();
    });

    this.buttonMode = false;

    this.cdRef.detectChanges();
  }

  setKiosk(enabled, key) {
    if (this.kiosk != null) {
      this.kiosk.unsubscribe();
      this.kiosk = null;
    }

    if (enabled) {
      this.taskbarEnabled = false;
      this.container.nativeElement.style.display = "none";
      if (key != null) {
        this.kiosk = fromEvent(document, 'keydown').subscribe((event: any) => {
          if (event.key == "Escape") {
            this.kioskKey = "";
            this.taskbarEnabled = false;
            this.container.nativeElement.style.display = "none";
          } else {
            this.kioskKey += event.key;
            if (this.kioskKey == key) {
              this.show = false;
              this.taskbarEnabled = true;
              this.showToolbar();
            }
          }
        });
      }
    } else {
      this.taskbarEnabled = true;
      this.showToolbar();
    }
  }

  showToolbar() {
    if (this.show == false) {
      this.show = true;
      this.cdRef.markForCheck();
      if (this.taskbarEnabled) {
        this.container.nativeElement.style.display = "flex";
      }
      document.body.style.cursor = '';
      document.exitPointerLock();
    }

    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.timeoutId = setTimeout(() => {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
      this.show = false;
      if (this.taskbarEnabled) {
        this.container.nativeElement.style.display = "none";
      }
      document.body.style.cursor = 'none';
      try {
        document.body.requestPointerLock();
      } catch (e) {

      }


    }, 5000);
  }


  onToolbarPlay() {
    this.playerService.play();
  }

  onToolbarStop() {
    this.playerService.stop();
  }

  updateButtons() {
    this.isPlaying = this.playerService.isPlaying();
  }

  onExit() {
    if (this.mousemove != null) {
      this.mousemove.unsubscribe();
      this.mousemove = null;
    }
    this.setKiosk(false, null);

    (<PlayerPwaService>this.playerService).watchdog.close();
  }

  onToggleFull() {
    this.isFullScreen = document.fullscreenElement;
    if (this.isFullScreen) {
      this.document.exitFullscreen();
    } else {
      this.document.getElementsByTagName('body')[0]['requestFullscreen']();
    }
    this.isFullScreen = !this.isFullScreen;
  }

  onInfo() {
    if (this.signageInfo == null) {
      //???this.ngZone.run(() => {
      this.signageInfo = this.dialog.open(SignageInfoComponent, {width: '700px', height: '350px'}).afterClosed()
        .subscribe(
          (data) => {
            this.signageInfo = null;
          }
        );
      //???});
    }
  }
}

